import { useEffect, useRef } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { Toaster } from "@/components/ui/sonner";
import api from "@/lib/api";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Section from "@/pages/Section";
import WritingDetail from "@/pages/WritingDetail";
import Premium from "@/pages/Premium";
import Shop from "@/pages/Shop";
import ShopDetail from "@/pages/ShopDetail";
import Corsi from "@/pages/Corsi";
import CourseDetail from "@/pages/CourseDetail";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Percorso from "@/pages/Percorso";
import Giorno from "@/pages/Giorno";
import Area from "@/pages/Area";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const r = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(r.data);
      } catch (e) {
        console.error("Auth session error:", e);
      } finally {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF5F1]">
      <div className="text-[#C6899E] font-serif text-2xl tracking-wide animate-pulse">UNFILTERED</div>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/su-di-me" element={<About />} />
        <Route path="/writing" element={<Section type="writing" />} />
        <Route path="/writing/:slug" element={<WritingDetail />} />
        <Route path="/video" element={<Section type="video" />} />
        <Route path="/short" element={<Section type="short" />} />
        <Route path="/audio" element={<Section type="audio" />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:id" element={<ShopDetail />} />
        <Route path="/corsi" element={<Corsi />} />
        <Route path="/corsi/:id" element={<CourseDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/area" element={<Area />} />
        <Route path="/percorso" element={<Percorso />} />
        <Route path="/percorso/giorno/:n" element={<Giorno />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LangProvider>
          <AppRouter />
          <Toaster position="bottom-center" theme="light" />
        </LangProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
